module.exports = __webpack_public_path__ + "img/105.b010447.svg";